var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("Funktionärer")]),_c('AddFunctionToMember')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }